<div class="card">
  <!-- Header with filters -->
  <div class="card-header border-bottom">
    <div class="d-flex flex-column flex-sm-row gap-3 align-items-start align-items-sm-center">
      <div class="d-flex align-items-center gap-2">
        <label class="text-nowrap fw-medium" for="recStatusFilter">{{ 'admin.recommendations.filterByStatus' | translate }}:</label>
        <select class="form-select form-select-sm" id="recStatusFilter" [(ngModel)]="statusFilter" (change)="onFilterChange()" style="width: auto;">
          <option value="">{{ 'admin.recommendations.allStatuses' | translate }}</option>
          <option value="pending">{{ 'admin.recommendations.statusPending' | translate }}</option>
          <option value="reviewed">{{ 'admin.recommendations.statusReviewed' | translate }}</option>
        </select>
      </div>
      <div class="text-muted text-nowrap ms-auto">
        <strong>{{ totalItems }}</strong> {{ 'admin.recommendations.totalCount' | translate | lowercase }}
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="card-body p-0">
    @if (loading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (recommendations.length === 0) {
      <div class="text-center py-5 text-muted">
        <i class="fa-solid fa-star fa-3x mb-3 opacity-50"></i>
        <p class="mb-0">{{ 'admin.recommendations.noResults' | translate }}</p>
      </div>
    } @else {
      <!-- Table header -->
      <div class="table-header">
        <div>{{ 'admin.recommendations.trainerName' | translate }}</div>
        <div>{{ 'admin.recommendations.description' | translate }}</div>
        <div>{{ 'admin.recommendations.specializations' | translate }}</div>
        <div>{{ 'admin.recommendations.contactInfo' | translate }}</div>
        <div>{{ 'admin.recommendations.status' | translate }}</div>
        <div>{{ 'admin.recommendations.submitted' | translate }}</div>
        <div>{{ 'admin.recommendations.actions' | translate }}</div>
      </div>

      <!-- Recommendation list -->
      <div class="recommendation-list">
        @for (rec of recommendations; track rec.recommendation_id) {
          <div class="recommendation-item">
            <div class="rec-name fw-medium">
              {{ rec.trainer_name }}
            </div>
            <div class="rec-description text-truncate">
              {{ rec.description }}
            </div>
            <div class="rec-specializations text-truncate">
              {{ rec.specializations || '-' }}
            </div>
            <div class="rec-contact text-truncate">
              {{ rec.contact_info || '-' }}
            </div>
            <div class="rec-status">
              <span class="badge" [ngClass]="getStatusBadgeClass(rec.status)">{{ rec.status }}</span>
            </div>
            <div class="rec-date">
              {{ rec.created_at | date:'dd.MM.yyyy' }}
            </div>
            <div class="rec-actions">
              @if (rec.status === 'pending') {
                <app-button variant="primary" size="sm" label="{{ 'admin.recommendations.markReviewed' | translate }}" (clicked)="markReviewed(rec)" [disabled]="actionLoading"></app-button>
              } @else {
                <span class="badge bg-success-subtle text-success">
                  <i class="fa-solid fa-check me-1"></i>{{ 'admin.recommendations.statusReviewed' | translate }}
                </span>
              }
            </div>
          </div>
        }
      </div>

      <!-- Pagination -->
      @if (totalPages > 1) {
        <div class="card-footer bg-light d-flex justify-content-between align-items-center">
          <span class="text-muted small">
            {{ 'admin.pagination.showing' | translate }} {{ (currentPage - 1) * perPage + 1 }}-{{ Math.min(currentPage * perPage, totalItems) }} {{ 'admin.pagination.of' | translate }} {{ totalItems }}
          </span>
          <nav>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="currentPage > 1 && onPageChange(currentPage - 1)">
                  <i class="fa-solid fa-chevron-left"></i>
                </a>
              </li>
              @for (page of getPages(); track page) {
                <li class="page-item" [class.active]="page === currentPage">
                  <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
                </li>
              }
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="currentPage < totalPages && onPageChange(currentPage + 1)">
                  <i class="fa-solid fa-chevron-right"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      }
    }
  </div>
</div>
